import { render } from "./FormActions.vue?vue&type=template&id=60d2d7a8&scoped=true"
import script from "./FormActions.vue?vue&type=script&lang=js"
export * from "./FormActions.vue?vue&type=script&lang=js"

import "./FormActions.vue?vue&type=style&index=0&id=60d2d7a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60d2d7a8"]])

export default __exports__